import { render, staticRenderFns } from "./monthlySupplyList.vue?vue&type=template&id=18145aaa&scoped=true"
import script from "./monthlySupplyList.vue?vue&type=script&lang=js"
export * from "./monthlySupplyList.vue?vue&type=script&lang=js"
import style0 from "./monthlySupplyList.vue?vue&type=style&index=0&id=18145aaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18145aaa",
  null
  
)

export default component.exports